// src/components/LandingContext.js
import { createContext } from 'react';

export const LandingContext = createContext(null);
